import { render, staticRenderFns } from "./Form2_Persona.vue?vue&type=template&id=28e68276"
import script from "./Form2_Persona.vue?vue&type=script&lang=js"
export * from "./Form2_Persona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e68276')) {
      api.createRecord('28e68276', component.options)
    } else {
      api.reload('28e68276', component.options)
    }
    module.hot.accept("./Form2_Persona.vue?vue&type=template&id=28e68276", function () {
      api.rerender('28e68276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/UY/Form2_Persona.vue"
export default component.exports